import { call, put, takeLatest } from 'redux-saga/effects';
import { getSelects, getMembers, getTemplates } from '../../../services/setting/mailMagazineEntry.service';
import {
  ACTION_TYPE,
  actCallInitMailMagazineEntrySuccess,
  actCallMailMagazineEntryMembersSuccess,
  actCallMailTemplatesSuccess,
} from './action';
import { actCallApiServerError } from '../../common/common/action';

/**
 * 初期表示
 *
 */
function* callApiInitMailMagazineEntry() {
  try {
    const selects = yield call(getSelects, {});
    yield put(actCallInitMailMagazineEntrySuccess(selects));
  } catch (error) {
    yield put(actCallApiServerError(error));
  }
}

/**
 * 会員取得
 *
 */
function* callApiMailMagazineEntryMembers({ searchCondition }) {
  try {
    const members = yield call(getMembers, searchCondition);
    yield put(actCallMailMagazineEntryMembersSuccess(members));
  } catch (error) {
    yield put(actCallApiServerError(error));
  }
}

/**
 * メールテンプレート取得
 *
 */
function* callApiMailTemplates({ storeId }) {
  try {
    const templates = yield call(getTemplates, storeId);
    yield put(actCallMailTemplatesSuccess(templates));
  } catch (error) {
    yield put(actCallApiServerError(error));
  }
}

/**
 * Export default root saga
 * @returns {IterableIterator<boolean>}
 */
export default function* watchCallMailMagazineEntry() {
  yield takeLatest(ACTION_TYPE.CALL_API_INIT_MAIL_MAGAZINE_ENTRY, callApiInitMailMagazineEntry);
  // eslint-disable-next-line max-len
  yield takeLatest(ACTION_TYPE.CALL_API_MAIL_MAGAZINE_ENTRY_MEMBERS, callApiMailMagazineEntryMembers);
  yield takeLatest(ACTION_TYPE.CALL_API_MAIL_TEMPLATES, callApiMailTemplates);
}
